/**
 * @generated SignedSource<<ba435270b87682c19f914dc37f188364>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type threadBody_AtlassianSearchPage$data = {
  readonly integrationId: string | null;
  readonly linkedEntities: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"threadMessage_AtlassianSearchPage">;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"threadMessage_AtlassianSearchPage">;
  readonly " $fragmentType": "threadBody_AtlassianSearchPage";
};
export type threadBody_AtlassianSearchPage$key = {
  readonly " $data"?: threadBody_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"threadBody_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "FragmentSpread",
  "name": "threadMessage_AtlassianSearchPage"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "threadBody_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "integrationId"
    },
    {
      "concreteType": "SearchResultGraphDocument",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        (v0/*: any*/)
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "a11eded9a6a51942258f01f5565479d1";

export default node;
